// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"161":"c7ef31f3","246":"ace0cdc9","395":"897b24fc"}[chunkId] + ".chunk.js";
};